/**
 * QuickActions Component
 * 7 quick action buttons matching backend handlers
 */

import React from 'react';

/**
 * Icon components for each quick action
 */
function WrenchIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
    </svg>
  );
}

function BoxIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
      <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
      <line x1="12" y1="22.08" x2="12" y2="12"></line>
    </svg>
  );
}

function SlidersIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14"></line>
      <line x1="4" y1="10" x2="4" y2="3"></line>
      <line x1="12" y1="21" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12" y2="3"></line>
      <line x1="20" y1="21" x2="20" y2="16"></line>
      <line x1="20" y1="12" x2="20" y2="3"></line>
      <line x1="1" y1="14" x2="7" y2="14"></line>
      <line x1="9" y1="8" x2="15" y2="8"></line>
      <line x1="17" y1="16" x2="23" y2="16"></line>
    </svg>
  );
}

function CogIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  );
}

function CircleIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <circle cx="12" cy="12" r="4"></circle>
    </svg>
  );
}

function AlertIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  );
}

function FileCodeIcon() {
  return (
    <svg className="chatbot-quick-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <polyline points="9 15 12 18 15 15"></polyline>
      <polyline points="9 11 12 8 15 11"></polyline>
    </svg>
  );
}

/**
 * Quick action definitions
 */
const QUICK_ACTIONS = [
  {
    id: 'troubleshoot',
    label: 'Troubleshoot',
    icon: WrenchIcon,
    description: 'Diagnose print issues'
  },
  {
    id: 'materials',
    label: 'Materials',
    icon: BoxIcon,
    description: 'Material selection guide'
  },
  {
    id: 'calibration',
    label: 'Calibration',
    icon: SlidersIcon,
    description: 'Calibration procedures'
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: CogIcon,
    description: 'Print settings optimizer'
  },
  {
    id: 'nozzle',
    label: 'Nozzle',
    icon: CircleIcon,
    description: 'Nozzle selection guide'
  },
  {
    id: 'safety',
    label: 'Safety',
    icon: AlertIcon,
    description: 'Safety guidelines'
  },
  {
    id: 'gcode',
    label: 'G-Code',
    icon: FileCodeIcon,
    description: 'G-code review'
  }
];

function QuickActions({ onAction, compact = false, disabled = false }) {
  return (
    <div className={`chatbot-quick-actions ${compact ? 'compact' : ''}`}>
      {QUICK_ACTIONS.map((action) => {
        const IconComponent = action.icon;
        return (
          <button
            key={action.id}
            className="chatbot-quick-btn"
            onClick={() => onAction(action.id)}
            disabled={disabled}
            type="button"
            title={action.description}
          >
            <IconComponent />
            <span>{action.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default QuickActions;
export { QUICK_ACTIONS };
